import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export const TimecardConfirmationModal = ({
  open,
  onClose,
  onApprove,
  weekEndingDate,
  summaryData,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Approve Time for Week Ending {formatDate(weekEndingDate)}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          You are about to approve all time entries you submitted for this week.
          Once approved, these timecards will be locked and cannot be edited.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Summary:
        </Typography>

        <Box sx={{ pl: 2 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Total Hours: {summaryData.totalHours.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Total Entries: {summaryData.totalEntries}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Straight Time: {summaryData.straightTime.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Overtime: {summaryData.overtime.toFixed(1)}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            • Double Time: {summaryData.doubleTime.toFixed(1)}
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mt: 3 }}>
          Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ minWidth: 120 }}>
          Cancel
        </Button>
        <Button
          onClick={onApprove}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120 }}
        >
          Approve Week
        </Button>
      </DialogActions>
    </Dialog>
  );
};
